import { useLocalStorageState } from '@fuxi/eevee-hooks';

// import { localStorageCommentKey } from '@/constants';
import { CachedCommentWithTTL } from '@/types';

export type CachedCommentResult = {
  getCachedComment: () => CachedCommentWithTTL | undefined;
  setCachedComment: (value: CachedCommentWithTTL) => void;
  syncCommentInfo: (value: CachedCommentWithTTL) => void;
  clearCachedComment: () => void;
};

export const useCachedComment = (cacheKey: string): CachedCommentResult => {
  const [cachedComment, setCachedComment] = useLocalStorageState<CachedCommentWithTTL | undefined>(cacheKey);

  const syncCommentInfo = (comment: CachedCommentWithTTL) => {
    //ttl单位是秒
    setCachedComment({ ...comment, ttl: Date.now() + comment.ttl * 1000 });
  };
  const clearCachedComment = () => {
    setCachedComment(undefined);
  };
  const getCachedComment = () => {
    if (cachedComment) {
      if (Date.now() <= cachedComment.ttl) {
        return cachedComment;
      } else {
        //过期缓存，清除
        setCachedComment(undefined);
      }
    }
    return undefined;
  };

  return {
    setCachedComment,
    syncCommentInfo,
    getCachedComment,
    clearCachedComment,
  };
};
